module.exports = __webpack_public_path__ + "media/images/payments/westernunion-556120eb2600403fa2f59d2061a3bfe5.svg";